import SlimSelect from 'slim-select'

const initSlimSelect = () => {
  document.querySelectorAll('select[data-slim-select]').forEach((el) => {
    // Skip if already initialized
    if (el.slim) {
      return
    }

    // eslint-disable-next-line no-new
    new SlimSelect({
      select: el,
      settings: {
        modal: 'off', // 4.x opens a modal dialog instead of the dropdown below 768px by default
        searchHighlight: true
      }
    })
  })
}

export default function setupSlimSelect () {
  // Initialize on Turbo frame updates
  document.addEventListener('turbo:frame-render', initSlimSelect)

  // Initialize when vanilla-nested adds new fields
  document.addEventListener('vanilla-nested:fields-added', initSlimSelect)

  // Return the init function so it can be called directly too
  return initSlimSelect
}
